import { FigureData } from "../../../models/figure/FigureData";
import { SquareView } from "../square/SquareView";
import { BaseFigureView } from "./BaseFigureView";

export class ShadowFigureView extends BaseFigureView {

    public constructor(
        figureData: FigureData,
        squares: Array<SquareView>
    ) {
        super(figureData, squares);
        this.alpha = 0.4;
    }
}
